import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGwSicherungsArtListStatus: 'idle',
    loadGwSicherungsArtListError: undefined as any,
    loadGwSicherungsArtListLastArgs: undefined as any,
    loadGwSicherungsArtStatus: 'idle',
    loadGwSicherungsArtError: undefined as any,
    saveGwSicherungsArtStatus: 'idle',
    saveGwSicherungsArtError: undefined as any,
    deleteGwSicherungsArtStatus: 'idle',
    deleteGwSicherungsArtError: undefined as any,

    gwSicherungsArtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGwSicherungsArtList = createAsyncThunk('gwSicherungsArtSlice/loadGwSicherungsArtList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().gwSicherungsArtSlice.loadGwSicherungsArtListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgwsichart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGwSicherungsArtListStatus } = getState().gwSicherungsArtSlice
        return loadGwSicherungsArtListStatus !== 'pending'
    }
})

export const loadGwSicherungsArt = createAsyncThunk('gwSicherungsArtSlice/loadGwSicherungsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgwsichart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGwSicherungsArtStatus } = getState().gwSicherungsArtSlice
        return loadGwSicherungsArtStatus !== 'pending'
    }
})

export const saveGwSicherungsArt = createAsyncThunk('gwSicherungsArtSlice/saveGwSicherungsArt', async ({ gwSicherungsArt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (gwSicherungsArt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisgwsichart/${ gwSicherungsArt?.HDR_ID }/`,
            prepareData(gwSicherungsArt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisgwsichart/`,
            prepareData(gwSicherungsArt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGwSicherungsArtStatus } = getState().gwSicherungsArtSlice
        return saveGwSicherungsArtStatus !== 'pending'
    }
})

export const deleteGwSicherungsArt = createAsyncThunk('gwSicherungsArtSlice/deleteGwSicherungsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisgwsichart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGwSicherungsArtStatus } = getState().gwSicherungsArtSlice
        return deleteGwSicherungsArtStatus !== 'pending'
    }
})

const GwSicherungsArtSlice = createSlice({
    name: 'gwSicherungsArtSlice',
    initialState,
    reducers: {
        resetloadGwSicherungsArtListError: (state) => {
            state.loadGwSicherungsArtListError = undefined
        },
        resetloadGwSicherungsArt: (state) => {
            state.formItem = undefined
            state.loadGwSicherungsArtError = undefined
        },
        resetloadGwSicherungsArtError: (state) => {
            state.loadGwSicherungsArtError = undefined
        },
        resetsaveGwSicherungsArt: (state) => {
            state.formItem = undefined
            state.saveGwSicherungsArtError = undefined
        },
        resetsaveGwSicherungsArtError: (state) => {
            state.saveGwSicherungsArtError = undefined
        },
        resetdeleteGwSicherungsArtError: (state) => {
            state.deleteGwSicherungsArtError = undefined
        },
        removeFromGwSicherungsArtListById: (state, action) => {
            state.gwSicherungsArtList = state.gwSicherungsArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGwSicherungsArtListByIds: (state, action) => {
            state.gwSicherungsArtList = state.gwSicherungsArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.gwSicherungsArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGwSicherungsArtListStatus = 'preloaded'
            state.loadGwSicherungsArtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.gwSicherungsArtList = []
            state.loadGwSicherungsArtListStatus = 'idle'
            state.loadGwSicherungsArtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGwSicherungsArtList.pending, (state) => {
            state.loadGwSicherungsArtListStatus = 'pending'
            state.loadGwSicherungsArtListError = undefined
        })
        builder.addCase(loadGwSicherungsArtList.fulfilled, (state, action) => {
            state.loadGwSicherungsArtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGwSicherungsArtListLastArgs = action.payload.args

            {
                state.gwSicherungsArtList = action.payload.data

            }
        })
        builder.addCase(loadGwSicherungsArtList.rejected, (state, action) => {
            state.loadGwSicherungsArtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGwSicherungsArtListError = action.error.message
            } else {
                state.loadGwSicherungsArtListError = action.payload
            }
        })

        builder.addCase(loadGwSicherungsArt.pending, (state) => {
            state.loadGwSicherungsArtStatus = 'pending'
            state.loadGwSicherungsArtError = undefined
        })
        builder.addCase(loadGwSicherungsArt.fulfilled, (state, action) => {
            state.loadGwSicherungsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gwSicherungsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gwSicherungsArtList.push(newItem) }
                else { state.gwSicherungsArtList[i] = { ...state.gwSicherungsArtList[i], ...newItem } }
            }
        })
        builder.addCase(loadGwSicherungsArt.rejected, (state, action) => {
            state.loadGwSicherungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGwSicherungsArtError = action.error.message
            } else {
                state.loadGwSicherungsArtError = action.payload
            }
        })

        builder.addCase(saveGwSicherungsArt.pending, (state) => {
            state.saveGwSicherungsArtStatus = 'pending'
            state.saveGwSicherungsArtError = undefined
        })
        builder.addCase(saveGwSicherungsArt.fulfilled, (state, action) => {
            state.saveGwSicherungsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gwSicherungsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gwSicherungsArtList.push(newItem) }
                else { state.gwSicherungsArtList[i] = { ...state.gwSicherungsArtList[i], ...newItem } }
            }
        })
        builder.addCase(saveGwSicherungsArt.rejected, (state, action) => {
            state.saveGwSicherungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGwSicherungsArtError = action.error.message
            } else {
                state.saveGwSicherungsArtError = action.payload
            }
        })

        builder.addCase(deleteGwSicherungsArt.pending, (state) => {
            state.deleteGwSicherungsArtStatus = 'pending'
            state.deleteGwSicherungsArtError = undefined
        })
        builder.addCase(deleteGwSicherungsArt.fulfilled, (state, action) => {
            state.deleteGwSicherungsArtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.gwSicherungsArtList = state.gwSicherungsArtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.gwSicherungsArtList = state.gwSicherungsArtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteGwSicherungsArt.rejected, (state, action) => {
            state.deleteGwSicherungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGwSicherungsArtError = action.error.message
            } else {
                state.deleteGwSicherungsArtError = action.payload
            }
        })

    }
})

export const {
    resetloadGwSicherungsArtListError,
    resetloadGwSicherungsArt,
    resetloadGwSicherungsArtError,
    resetsaveGwSicherungsArt,
    resetsaveGwSicherungsArtError,
    resetdeleteGwSicherungsArtError,
    removeFromGwSicherungsArtListById,
    removeFromGwSicherungsArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GwSicherungsArtSlice.actions
export default GwSicherungsArtSlice.reducer
